import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["saleLineItem", "saleTotalDisplay"]

  connect() {
    this.calculateSale()
  }

  calculateSale() {
    this.saleLineItemTargets.forEach((lineItem) => {
      this.calculateLineItem(lineItem)
    })
    this.calculateSaleTotal()
  }

  calculateLineItem(lineItem) {
    const quantity = lineItem.querySelector('[data-quantity-input="true"]').value
    const unitPrice = lineItem.querySelector('[data-unit-price-input="true"]').value
    const totalPrice = (quantity * unitPrice).toFixed(2)
    
    const lineItemTotalDisplay = lineItem.querySelector('[data-line-item-total-display="true"]')
    lineItemTotalDisplay.textContent = totalPrice
  }

  calculateSaleTotal() {
    let total = 0.00
    this.saleLineItemTargets.forEach((lineItem) => {
      const lineItemTotalDisplay = lineItem.querySelector('[data-line-item-total-display="true"]')
      total += parseFloat(lineItemTotalDisplay.textContent)
    })
    this.saleTotalDisplayTarget.textContent = `£${total.toFixed(2)}`
  }
}